import { AxiosError, isAxiosError } from "axios"
import { CUSTOMER_ATTACHMENTS_USER_KEYS } from "customerAttachments/auth/AuthProvider"
import setupAPI from "utils/apiUtil"

import { callGlobalErrorHandler } from "./globalErrorHandler"

type ApiErrorResponse = {
  Result: number
  Message: string | null
  MessageCode: string | null
  MessageCodeParams: unknown
  Track: unknown
}

const responseErrorHandler = (error: Error | AxiosError) => {
  if (!isAxiosError(error) || !error.response) return

  const status = error.response?.status

  if (status === 401) {
    localStorage.removeItem(CUSTOMER_ATTACHMENTS_USER_KEYS)
    window.location.href = "/login"
    return
  }

  if (status >= 400 && status < 500) {
    window.location.href = "/error"
    return
  }

  if (status >= 500) {
    callGlobalErrorHandler(error)
  }
}

export const handleErrorMessageCode = (error: unknown) => {
  if (isAxiosError(error)) {
    const data = error.response?.data as ApiErrorResponse | undefined
    if (data?.MessageCode) {
      return data.MessageCode
    }
  }

  if (error instanceof Error) {
    return error.message
  }

  return "An unexpected error occurred."
}

export default setupAPI({ responseErrorHandler })
